import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationComponent } from './registration.component';
import { RegistrationRoutingModule } from './registration-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule, AlertConfig } from 'ngx-bootstrap/alert';
import { OtpGenerationComponent } from '../components/otp-generation/otp-generation.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    RegistrationComponent, OtpGenerationComponent
  ],
  imports: [
    CommonModule, RegistrationRoutingModule, FormsModule,
    ReactiveFormsModule, AlertModule, SharedModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [AlertConfig]
})
export class RegistrationModule { }
